// Polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { ColorThemePlugin } from "../services/vuestic-ui";
import store from "../store/index";
import router from "../router/index";
import { VuesticPlugin } from "../services/vuestic-ui/components";
import "../i18n/index";
import YmapPlugin from "vue-yandex-maps";
import VueClipboard from "vue-clipboard2";

import Cookies from "js-cookie";

import "../metrics";
import "../registerServiceWorker";

import { consoleBuildInfo } from "vue-cli-plugin-build-info/plugin";

consoleBuildInfo();

Vue.use(VuesticPlugin);
Vue.use(YmapPlugin);
Vue.use(VueClipboard);

Vue.use(ColorThemePlugin, {
  // override colors here.
  primary: "#31A479",
  secondary: "#21383E"
});

/*router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)

  if (!Cookies.get('admin-logged') && to.name !== 'login') {
    next('/login')
  } else {
    next()
  }
})*/

// main.js
router.beforeEach((to, from, next) => {
  store.commit("setLoading", true);

  const isLogged =
    (Cookies.get("admin-logged") ? true : false) &&
    (Cookies.get("user") ? true : false);
  const needsAuth = to.matched.some(r => r.meta && r.meta.requiresAuth);

  if (needsAuth && !isLogged) {
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  if (isLogged && to.name === "login") {
    return next({ name: "categories" });
  }

  return next();
});

router.afterEach(() => {
  store.commit("setLoading", false);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
